import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { DialogAudioSection } from '../DialogAudioSection/DialogAudioSection';
import { DialogListSection, type DialogListSectionProps } from '../dialogsListSection/DialogListSection';
import { SessionDetails } from '../SessionDetails/SessionDetails';

type Props = {
  listSection?: FC<DialogListSectionProps>;
};

export const DialogVisualizerLayout: FC<Props> = ({ listSection }) => {
  const { id } = useParams<{ id: string }>();
  const ListSection = listSection ?? DialogListSection;

  if (!id) {
    return <ListSection className="h-full relative w-full" />;
  }

  return (
    <div className={'grid grid-rows-[auto_1fr] grid-cols-1 gap-4 h-full'}>
      <DialogAudioSection />
      <SessionDetails id={+id} />
    </div>
  );
};
